import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class ConfigurationService {

    getConfigurations(params, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configurations',
                method: 'get',
                params: params,
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getConfiguration(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration/' + uuid,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postConfiguration(data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putConfiguration(uuid, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration/' + uuid,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }



    deleteConfiguration(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration/' + uuid,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}